export const WORKSHEET_DISABLE_STATUSES = [ 'Request', 'Запрос' ];
export const MASS_WORKSHEET_TYPES = ['Массовый подбор', 'Mass recruitment'];
export const MASSWORKSHEET_TYPES_ID = [53];
